import { ICargo } from '../entities/cargoes'
import { cargoes } from '../entities/cargoes-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { l } from '../lib/imports'
import { IJob } from './jobs'
import { jobs } from './jobs-sidecar'

export function advanceJob(job: IJob) {
  // TODO: register

  if (job.isComplete) {
    if (job.isFailed) {
      console.log('failed job!', job.type)
    } else {
      console.log('completed job!')
    }
    job.isDead = true
  }

  l.forEach(job.tasks, (c) => {
    if (c.isFailed) {
      console.log('failed task!', job.type, c.type)
      job.isFailed = true
      job.isDead = true
    }
  })

  if (job.isDead) {
    if (job.reservedBy) {
      jobs.unassignJob(job.reservedBy)
    }
    return
  }

  let action = jobs.getRegisteredJob(job.type)
  action(job)
}

export function findCargoF(
  x: number,
  y: number,
  cargoFilter: (f: ICargo) => boolean,
  invalidCargoes: ICargo[],
  allowFromStack: boolean,
): ICargo | null {
  if (!allowFromStack) {
    return cargoes.findClosestTo(
      x,
      y,
      (c) => cargoFilter(c) && c.inStack === null,
      invalidCargoes,
    )
  }

  return cargoes.findClosestTo(x, y, cargoFilter, invalidCargoes)
}

export function findCargo(
  x: number,
  y: number,
  type: ICargoType,
  invalidCargoes: ICargo[],
  allowFromStack: boolean,
): ICargo | null {
  return findCargoF(
    x,
    y,
    (f) => f.data.type === type,
    invalidCargoes,
    allowFromStack,
  )
}
